var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "list-box" },
    [
      _c("hr"),
      _c("h3", [_vm._v("促销范围")]),
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        _vm._l(_vm.areaList, function (item, index) {
          return _c("el-tab-pane", {
            key: index,
            attrs: { label: item.dictValue, name: item.dictCode },
          })
        }),
        1
      ),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 20, offset: 1 } },
            [
              _c("h5", [_vm._v("包含")]),
              _vm.notView
                ? _c("vxe-toolbar", {
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "buttons",
                          fn: function () {
                            return [
                              _c(
                                "vxe-button",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.addTable(true)
                                    },
                                  },
                                },
                                [_vm._v("添加")]
                              ),
                              _c(
                                "vxe-button",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.beforeDelete(true)
                                    },
                                  },
                                },
                                [_vm._v("删除")]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      345138844
                    ),
                  })
                : _vm._e(),
              _vm.tableObj[_vm.activeName]
                ? _c(
                    "vxe-table",
                    {
                      ref: "dataY",
                      attrs: {
                        align: _vm.allAlign,
                        data: _vm.tableObj[_vm.activeName].dataY,
                      },
                      on: {
                        "checkbox-all": function (ref) {
                          var records = ref.records

                          return _vm.selectAllEvent(records)
                        },
                        "checkbox-change": function (ref) {
                          var records = ref.records

                          return _vm.selectChangeEvent(records)
                        },
                      },
                    },
                    [
                      _c("vxe-table-column", {
                        attrs: { type: "checkbox", width: "50" },
                      }),
                      _vm._l(
                        _vm.tableObj[_vm.activeName].column,
                        function (config, index) {
                          return _c(
                            "vxe-table-column",
                            _vm._b(
                              { key: index },
                              "vxe-table-column",
                              config,
                              false
                            )
                          )
                        }
                      ),
                    ],
                    2
                  )
                : _vm._e(),
              _c("h5", [_vm._v("非包含")]),
              _vm.notView
                ? _c("vxe-toolbar", {
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "buttons",
                          fn: function () {
                            return [
                              _c(
                                "vxe-button",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.addTable(false)
                                    },
                                  },
                                },
                                [_vm._v("添加")]
                              ),
                              _c(
                                "vxe-button",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.beforeDelete(false)
                                    },
                                  },
                                },
                                [_vm._v("删除")]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      2391563196
                    ),
                  })
                : _vm._e(),
              _vm.tableObj[_vm.activeName]
                ? _c(
                    "vxe-table",
                    {
                      ref: "dataN",
                      attrs: {
                        align: _vm.allAlign,
                        data: _vm.tableObj[_vm.activeName].dataN,
                      },
                      on: {
                        "checkbox-all": function (ref) {
                          var records = ref.records

                          return _vm.selectAllEvent(records)
                        },
                        "checkbox-change": function (ref) {
                          var records = ref.records

                          return _vm.selectChangeEvent(records)
                        },
                      },
                    },
                    [
                      _c("vxe-table-column", {
                        attrs: { type: "checkbox", width: "50" },
                      }),
                      _vm._l(
                        _vm.tableObj[_vm.activeName].column,
                        function (config, index) {
                          return _c(
                            "vxe-table-column",
                            _vm._b(
                              { key: index },
                              "vxe-table-column",
                              config,
                              false
                            )
                          )
                        }
                      ),
                    ],
                    2
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c("SelectConfig", {
        ref: "selectConfig",
        on: { onGetSelect: _vm.onGetSelect },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }